import type { ControllerRenderProps } from 'react-hook-form'

import AsyncSelect from '@molecules/AsyncSelect'
import type { SelectOption } from '@utils/types'

import { useEventRsvpOptions } from './useEventRsvpOptions'

type EventRsvpsSelectProps = {
  field: ControllerRenderProps<any, any>
  displayName: string
  hideLabel?: boolean
}

export function EventRsvpsSelect({ field, displayName, hideLabel }: EventRsvpsSelectProps) {
  const { options, optionLabel } = useEventRsvpOptions()

  // A reopened dialog labels each stored option with its value (the event id),
  // so rebuild the labels from the event list before the select shows them.
  const labelledField = {
    ...field,
    value: Array.isArray(field.value)
      ? field.value.map((option: SelectOption) => ({ value: option.value, label: optionLabel(option.value) }))
      : field.value,
  }

  return (
    <AsyncSelect
      dataTestId="event-rsvps-select"
      field={labelledField}
      displayName={displayName}
      hideLabel={hideLabel}
      defaultOptions={options}
      loadOptions={async (inputValue: string) =>
        options.filter((option) => option.label.toLowerCase().includes(inputValue.toLowerCase()))
      }
      debounceSearch={false}
      isCreatable={false}
      totalCount={options.length}
    />
  )
}
